import { createAction, props } from '@ngrx/store';

import { DatapointLookupCollection } from '../../features/unified-datapoint/models/datapoint-lookup-collection.model';

export namespace DatapointLookupActions {
  export const LoadLookup = createAction('[DatapointLookup] Load Lookup');
  export const LoadLookupSuccess = createAction(
    '[DatapointLookup] Load Lookup Success',
    props<{ lookup: DatapointLookupCollection }>()
  );
  export const LoadLookupFail = createAction(
    '[DatapointLookup] Load Lookup Fail',
    props<{ error: any }>()
  );

  export const LoadTopicLookup = createAction(
    '[DatapointLookup] Load Topic Lookup',
    props<{ id: string }>()
  );
  export const LoadTopicLookupSuccess = createAction(
    '[DatapointLookup] Load Topic Lookup Success',
    props<{ lookup: DatapointLookupCollection }>()
  );
  export const LoadTopicLookupFail = createAction(
    '[DatapointLookup] Load Topic Lookup Fail',
    props<{ error: any }>()
  );

  export const LoadFormulaLookup = createAction(
    '[DatapointLookup] Load Formula Lookup',
    props<{ id: string }>()
  );
  export const LoadFormulaLookupSuccess = createAction(
    '[DatapointLookup] Load Formula Lookup Success',
    props<{ lookup: DatapointLookupCollection }>()
  );
  export const LoadFormulaLookupFail = createAction(
    '[DatapointLookup] Load Formula Lookup Fail',
    props<{ error: any }>()
  );
}
